/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon';
icon.register({
	pdf: {
		width: 128,
		height: 128,
		viewBox: '0 0 1024 1024',
		data:
			'<path pid="0" d="M869 277.3H657.2v-212l212 212zm-238.2 26.3V65.3H154.3v417h714.8V303.5H630.8zM295 664c-5-3-11-5-17.6-6.2a132 132 0 0 0-20.8-1.6h-48.8V742h48.8c7.2 0 14.1-.5 20.8-1.6 6.7-1 12.5-3.1 17.6-6.2 5-3 9.1-7.4 12.2-13 3-5.6 4.6-13 4.6-22 0-9.1-1.5-16.4-4.6-22-3-5.6-7.1-10-12.2-13zM35.8 541.8v417h952.4v-417H35.8zM367.2 733a79 79 0 0 1-47.8 50 119 119 0 0 1-45.6 7.8h-66v102.5h-62.9V607.5h128.9c17.9 0 33 2.6 45.6 7.8a79.3 79.3 0 0 1 47.8 49.8 108.1 108.1 0 0 1 0 67.9zM645 806.4a127 127 0 0 1-24.2 45.6 113.5 113.5 0 0 1-40.4 30.3c-16.2 7.3-35.2 11-57 11H400V607.5h123.2c18.4 0 35.6 3 51.5 8.8a111.6 111.6 0 0 1 41.2 26.4 122 122 0 0 1 27.2 44c6.5 17.7 9.8 38.3 9.8 62 0 20.9-2.7 40.1-8 57.7zm245.4-146H752.2v66h119.7v48.8H752.2v118h-62.8V607.6h200.9v52.8zM572 686a61.3 61.3 0 0 0-25.5-19 101.5 101.5 0 0 0-39-6.7h-44.8v180.1h56c9.1 0 18-1.4 26.4-4.4 8.6-2.9 16.2-7.8 22.9-14.6 6.6-6.8 12-15.6 16-26.6 4-11 6-24.3 6-40 0-14.4-1.4-27.4-4.2-39A77.9 77.9 0 0 0 572 686zm0 0"/>'
	}
});
